// extracted by mini-css-extract-plugin
module.exports = {"pending-items-body":"styles-module__pending-items-body___1Onyf"};